module.exports = __webpack_public_path__ + "img/cp-library-metrics.19cf3d9b.svg";